<div class="app-layout">
	<app-header class="app-layout__header" [userInfo]="userInfo$ | async"></app-header>

	<div class="app-layout__mobile-spacer u-full-width d-block d-lg-none"></div>
	<div class="app-layout__desktop-spacer u-full-width d-none d-lg-block"></div>

	<mat-sidenav-container [hasBackdrop]="(mobile$ | async)" class="app-layout__content">
		<mat-sidenav *ngIf="(mobile$ | async) === false" mode="side" fixedInViewport [fixedTopGap]="105" position="end"
								 class="app-layout__sidebar--desktop" [opened]="shoppingCartOpened$.value">
			<app-shopping-cart [mobile$]="mobile$" (closeShoppingCart)="shoppingCartOpened$.next(false)"></app-shopping-cart>
		</mat-sidenav>

		<mat-sidenav *ngIf="mobile$ | async" mode="over" fixedInViewport [fixedTopGap]="69" position="end"
								 class="app-layout__sidebar--mobile" [opened]="shoppingCartOpened$.value">
			<app-shopping-cart [mobile$]="mobile$" (closeShoppingCart)="shoppingCartOpened$.next(false)"></app-shopping-cart>
		</mat-sidenav>

		<mat-sidenav-content>
			<app-navigation [userInfo]="userInfo$ | async"></app-navigation>

			<app-banner></app-banner>

			<div class="app-layout__shopping-cart-toggle">
				<app-shopping-cart-toggle
					(openShoppingCart)="shoppingCartOpened$.next(true)"
					[highlight$]="shoppingCartToggleHighlighted$"></app-shopping-cart-toggle>
			</div>

			<div class="app-layout__content">
				<router-outlet></router-outlet>
			</div>

			<app-footer></app-footer>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>

